import axios from "axios";

/**
 * Fetches customer transfer requests from DOS.
 * @param {string} userId - Required customer user ID
 * @param {Object} [filters] - Optional filter parameters
 * @param {string} [filters.transfer_request_type]
 * @param {string} [filters.mac_address]
 * @param {string} [filters.status]
 * @returns {Promise<Object>} Response data from the API
 */
export function fetchCustomerTransfers(userId, filters = {}) {
  const params = { user_id: userId };

  Object.keys(filters).forEach((key) => {
    if (filters[key] != null && filters[key] !== "") {
      params[key] = filters[key];
    }
  });

  return axios
    .get("v2/dos/customer_transfers", { params })
    .then((response) => response.data.transfer_requests || [])
    .catch((error) => Promise.reject(error));
}

/**
 * Fetches device transfers for a specific transfer request.
 * @param {string} transferRequestId - The transfer request ID
 * @param {string} userId - Required customer user ID
 * @returns {Promise<Object>} Response data from the API
 */
export function fetchDeviceTransfers(transferRequestId, userId) {
  const params = { user_id: userId };

  return axios
    .get(`v2/dos/${transferRequestId}/device_transfers`, { params })
    .then((response) => response.data.device_transfers || [])
    .catch((error) => Promise.reject(error));
}
